<template>
    <form-select
        label="Vendor:"
        :value="value"
        :options="vendorOptions"
        :error="error"
        @input="handleValueChange"
    ></form-select>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FormSelect from '../../generic/form-select/form-select.vue';

    export default {
        name: 'RentalExpenseVendorSelect',
        components: {
            FormSelect,
        },
        props: {
            value: {
                type: Number,
                default: null,
            },
            error: {
                type: String,
                default: null,
            }
        },
        computed: {
            ...mapGetters('workOrders', [
                'vendors',
            ]),
            vendorOptions() {
                return [
                    { value: null, text: 'Not Selected' },
                    ...this.vendors.map(vendor => ({
                        value: vendor.id,
                        text: vendor.company,
                    })),
                ];
            },
        },
        methods: {
            handleValueChange(value) {
                this.$emit('input', value);
            }
        }
    }
</script>
